import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse, AxiosError } from 'axios';
import {
    STORE_RXORDERDATA,
    STORE_DESIGNTYPE_RXFORM,
    STORE_NOTATIONS_RXFORM,
    STORE_PRODUCT_RXFORM,
    STORE_PRODUCTNAME_RXFORM,
    STORE_MODEL_RXFORM,
    STORE_GETMESSAGES,
    STORE_FILES_MSGATTACHMENT,
    STORE_MESSAGE_RXFORM_MESSAGE,
    AttachementData,
    STORE_FILES_GETATTACHMENT,
    STORE_GETDATAFILES,
    GetUserMessage,
    GetFileData,
} from 'src/reducers/rxForm';
import { STORE_ERROR_FILES_UPLOADED_MSG, STORE_ERROR_FILES_UPLOADED } from 'src/reducers/errors';
import { inputCharacterHandeling } from './supportAction';
import { STORE_LOADER } from 'src/reducers/landingPage';
import { STORE_VIEWFEEDBACK, ViewFeedback } from 'src/reducers/completeorderfile';
// import { fromDate } from './completeOrderAction';

export const clearDataOnOpen = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const getUserMessage: GetUserMessage[] = [];
    const getFileData: GetFileData[] = [];

    dispatch({ type: STORE_GETMESSAGES, getUserMessage } as AnyAction);
    dispatch({ type: STORE_GETDATAFILES, getFileData } as AnyAction);

};

export const getRxOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const sessionid = getState().user.userDetails.s || '';
    await axios({
        method: 'post',
        url: `${getState().environment.API_URL}getRxOrderDetails?orderId=${getState().liveOrder.orderid}`,
        headers: {
            sessionid: sessionid || ''
        },
    }).then(function (response: AxiosResponse) {

        const userRxdata = response.data;
        
        dispatch({ type: STORE_RXORDERDATA, userRxdata } as AnyAction);

        const designtype = getState().UserRxFormData.userRxdata[0].designtype;
        const notations = getState().UserRxFormData.userRxdata[0].notations;
        const product = getState().UserRxFormData.userRxdata[0].product;
        const productname = getState().UserRxFormData.userRxdata[0].productname;
        const model = getState().UserRxFormData.userRxdata[0].model;

        dispatch({ type: STORE_DESIGNTYPE_RXFORM, designtype } as AnyAction);
        dispatch({ type: STORE_NOTATIONS_RXFORM, notations } as AnyAction);
        dispatch({ type: STORE_PRODUCT_RXFORM, product } as AnyAction);
        dispatch({ type: STORE_PRODUCTNAME_RXFORM, productname } as AnyAction);
        dispatch({ type: STORE_MODEL_RXFORM, model } as AnyAction);

        return true;

    }).catch(error => {

        const errorFileUploadedOpen = true;
        const errorfilemsg = error.response.data.msg;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);

        return true;

    });

};

export const getFeedbackData = async (
    dispatch: Dispatch<AppState>,
    getState: () => AppState
  ) => {
    const sessionid = getState().user.userDetails.s || '';
    const feedbackstatus = getState().completeOrder.viewCompleteOrder[0]?.feedback || '';
    const viewCmptApiUrl = `${getState().environment.API_URL}updateviewcmpt`;
    const ViewApiUrl = `${getState().environment.API_URL}getFeedbackData?porderno=${encodeURIComponent(
      getState().liveOrder.orderid || ''
    )}`;
  
    // Show loader
    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);
  
    try {
      const response = await axios.get(ViewApiUrl, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          sessionid: sessionid,
        },
      });
      const feedbackid = response.data?.feedbackid || '';
      const viewFeedback: ViewFeedback = response.data || {};
      dispatch({ type: STORE_VIEWFEEDBACK, viewFeedback } as AnyAction);
  
      if (feedbackstatus === '3') {
        try {
          const viewdata = {
            feedbackid: feedbackid,
            status: '1',
          };
  
          await axios.post(viewCmptApiUrl, viewdata, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              sessionid: sessionid,
            },
          });
        } catch (error) {
          console.error('Error updating feedback status:', error.message);
        }
      }
    } catch (error) {
      console.error('Error fetching feedback data:', error.message);
  
      // Reset state on error
      dispatch({ type: STORE_VIEWFEEDBACK, viewFeedback: {} } as AnyAction);
    } finally {
      // Hide loader
      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
    }
  };

export const messaging = (message: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_MESSAGE_RXFORM_MESSAGE, message } as AnyAction);
        return true;
    };
};

function addAttachments(v: GetUserMessage) {
    return { ...v, attachments: [] };
}

export const messageObjectTransform = (messages: GetUserMessage[]) => {

    try {

        const addedField = messages.map(addAttachments);

        const setObj = new Set();

        const result = addedField.reduce(
            (acc: GetUserMessage[], item: GetUserMessage) => {
                if (!setObj.has(item.messageid)) {
                    setObj.add(item.messageid);
                    acc.push(item);
                } else {
                    const newIndex = acc.map(ele => ele.messageid).indexOf(item.messageid);
                    acc[newIndex].attachments.push({ attachfilename: item.attachfilename, oci_status: item.oci_status });
                }
                return acc;
            },
            []);

        return result;
    } catch (e) {
        return [];
    }

};

export const getMessage = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const sessionid = getState().user.userDetails.s || '';
    await axios({
        method: 'post',
        url: `${getState().environment.API_URL}getOrderMessage?messageType=0&pid=${getState().liveOrder.orderid}`,
        headers: {
            sessionid: sessionid || ''
        },
    }).then(function (response: AxiosResponse) {

        const getUserMessage = response.data;
        dispatch({ type: STORE_GETMESSAGES, getUserMessage: messageObjectTransform(getUserMessage) } as AnyAction);

    }).catch(error => {
        dispatch({ type: STORE_GETMESSAGES, getUserMessage: [] } as AnyAction);
        const errorFileUploadedOpen = true;
        const errorfilemsg = error.response.data.msg;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    });

};

export const onFilesChange = (fileatBox: Array<File>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        if (fileatBox.length === 0) {
            fileatBox.length = 0;
            dispatch({ type: STORE_FILES_MSGATTACHMENT, messageFiles: [] } as AnyAction);
            return;
        }

        const messageFilesInitial: Array<File> = fileatBox.filter((file) => file.name !== '');

        fileatBox.length = 0;
        const filterfile: Array<File> = getState().UserRxFormData.messageFiles.concat(messageFilesInitial);
        const seen = new Set();
        const messageFiles = filterfile.filter(el => {
            const duplicate = seen.has(el.name);
            seen.add(el.name);
            return !duplicate;
        });
        dispatch({ type: STORE_FILES_MSGATTACHMENT, messageFiles } as AnyAction);
    };
};

export const onFilesError = (error: Error, images: Array<File>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        // ==> console.error(error.message);
        // images.length = 0;
    };
};

export const sendMessageAttachment = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    try {

        const sessionid = getState().user.userDetails.s || '';

        let input = getState().UserRxFormData.message;

        const myAtts = getState().UserRxFormData.messageFiles;

        const attachments: Array<AttachementData> = [];

        dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

        if (myAtts.length > 0) {

            for (const myAtt of myAtts) {

                const formDataS = new FormData();

                formDataS.append('filetoattach', myAtt);
                input = getState().UserRxFormData.message || 'Attachment';

                const message = '';
                dispatch({ type: STORE_MESSAGE_RXFORM_MESSAGE, message } as AnyAction);

                await axios({
                    method: 'post',
                    url: `${getState().environment.API_URL}attachMessageFile`,
                    data: formDataS,
                    headers: {
                        orderid: getState().liveOrder.orderid,
                        sourcetype: 'Message',
                        dsorderid: '',
                        sessionid: sessionid || '',
                        filepath: getState().completeOrder.viewCompleteOrder[0].fpath || ''
                    },
                }).then(function (response: AxiosResponse) {

                    if (response.data.status) {

                        attachments.push({
                            attachmentname: response.data.fileName,
                            attachfilename: `${response.data.location}/${response.data.fileName}`
                        });

                    }
                }).catch(function (error: AxiosError) {

                    // ==> console.error(error.message);
                });
            }

            const params = {
                columns: {
                    messagetype: '',
                    message: '',
                    caseno: '',
                    refmessageid: '',
                },
                attachments: attachments
            };

            params.columns.messagetype = '0';
            params.columns.message = inputCharacterHandeling(input);
            params.columns.caseno = getState().liveOrder.orderid || '';
            params.columns.refmessageid = '';

            params.attachments = attachments;

            await axios({
                method: 'post',
                url: `${getState().environment.API_URL}sendMessage`,
                data: params,
                headers: {
                    sessionid: sessionid || ''
                },
            }).then(function (responseResult: AxiosResponse) {
                dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
                getMessage(dispatch, getState);

                const messageFiles: Array<File> = [];
                dispatch({ type: STORE_FILES_MSGATTACHMENT, messageFiles });

                const getAttachementData: Array<AttachementData> = [];
                dispatch({ type: STORE_FILES_GETATTACHMENT, getAttachementData } as AnyAction);

            }).catch(function (error: AxiosError) {
                dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

                // ==> console.error(error.message);
            });

        } else {
            const params = {

                columns: {
                    messagetype: '',
                    message: '',
                    caseno: '',
                    refmessageid: '',
                },
                attachments: attachments
            };

            params.columns.messagetype = '0';
            params.columns.message = inputCharacterHandeling(input);
            params.columns.caseno = getState().liveOrder.orderid || '';
            params.columns.refmessageid = '';

            params.attachments = attachments;

            await axios({
                method: 'post',
                url: `${getState().environment.API_URL}sendMessage`,
                data: params,
                headers: {
                    sessionid: sessionid || ''
                },
            }).then(function (response: AxiosResponse) {
                dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
                getMessage(dispatch, getState);

                const message = '';
                dispatch({ type: STORE_MESSAGE_RXFORM_MESSAGE, message } as AnyAction);

            }).catch(function (error: AxiosError) {
                dispatch({ type: STORE_LOADER, loader: false } as AnyAction);
                // ==> console.error(error.message);
            });
        }
        return true;
    } catch (err) {
        return true;
    }
};

export const downloadAttachment = (msgAttachment: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const filePath = encodeURIComponent(msgAttachment);
        await axios({
            method: 'get',
            url: `${getState().environment.API_URL}getDownloadUrl?fullPath=${filePath}`,
        }).then(function (response: AxiosResponse) {
            // attachfilename
            window.open(response.data.signedUrl);
        }).catch(function (error: AxiosResponse) {
            // ==> console.error(error);
        });
    };
};

export const getFiles = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const sessionid = getState().user.userDetails.s || '';
    await axios({
        method: 'post',
        url: `${getState().environment.API_URL}getFiles?orderId=${getState().liveOrder.orderid}`,
        headers: {
            sessionid: sessionid || ''
        },
    }).then(function (response: AxiosResponse) {
        const getFileData = response.data;
        dispatch({ type: STORE_GETDATAFILES, getFileData } as AnyAction);

    }).catch(function (error: AxiosError) {
        dispatch({ type: STORE_GETDATAFILES, getFileData: [] } as AnyAction);
    });
};



// WEBPACK FOOTER //
// ./src/actions/rxformAction.ts